import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

// axios 기본 URL 설정 (선택사항)
// axios.defaults.baseURL = 'http://localhost:3000' // API 서버의 기본 URL

// axios 인터셉터 설정
axios.interceptors.request.use(
  config => {
    const token = store.getters.getToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 응답 인터셉터 (선택사항, 에러 로깅용)
axios.interceptors.response.use(
  response => response,
  error => {
    console.error('API 요청 중 오류 발생:', error)
    return Promise.reject(error)
  }
)

const app = createApp(App)

// axios를 전역적으로 사용할 수 있도록 설정
app.config.globalProperties.$axios = axios

app.use(store).use(router).mount('#app')